/** Tennis match officiating — minimum hiring charges (KES). Keep in sync with backend match.py */
export const FIRST_OFFICIAL_MIN_HIRE_KES = 2000;
export const ADDITIONAL_OFFICIAL_MIN_HIRE_KES = 1000;
export const TENNIS_MAX_OFFICIATING_SLOTS = 4;

export const OFFICIATING_COUNT_OPTIONS = [
  {
    count: 1,
    label: "1 Official",
    summary: "Chair umpire only — common for singles",
    icon: "fa-solid fa-chair",
  },
  {
    count: 2,
    label: "2 Officials",
    summary: "Chair umpire + line umpire",
    icon: "fa-solid fa-flag",
  },
  {
    count: 3,
    label: "3 Officials",
    summary: "Chair, line + roving umpire",
    icon: "fa-solid fa-person-walking",
  },
  {
    count: 4,
    label: "4 Officials",
    summary: "Full crew incl. match referee",
    icon: "fa-solid fa-user-shield",
  },
];

export const OFFICIATING_SLOTS = [
  {
    slot: 1,
    label: "Chair Umpire",
    role: "Primary chair umpire",
    icon: "fa-solid fa-chair",
  },
  {
    slot: 2,
    label: "Line Umpire",
    role: "Baseline / sideline judge",
    icon: "fa-solid fa-flag",
  },
  {
    slot: 3,
    label: "Roving Umpire",
    role: "Court coverage & overrules",
    icon: "fa-solid fa-person-walking",
  },
  {
    slot: 4,
    label: "Referee",
    role: "Tournament / match referee",
    icon: "fa-solid fa-user-shield",
  },
];

const FORMAT_MAX_OFFICIALS = {
  singles: 3,
  doubles: 4,
};

export function officiatingSlotMinimumKes(slotNumber) {
  if (slotNumber <= 0) return 0;
  if (slotNumber === 1) return FIRST_OFFICIAL_MIN_HIRE_KES;
  return ADDITIONAL_OFFICIAL_MIN_HIRE_KES;
}

export function officiatingMinimumCostKes(slotsRequested) {
  if (!slotsRequested || slotsRequested <= 0) return 0;
  const capped = Math.min(Number(slotsRequested), TENNIS_MAX_OFFICIATING_SLOTS);
  let total = 0;
  for (let slot = 1; slot <= capped; slot += 1) {
    total += officiatingSlotMinimumKes(slot);
  }
  return total;
}

export function formatKes(amount) {
  return `KSh ${Number(amount).toLocaleString("en-KE")}`;
}

export function activeOfficiatingSlots(count) {
  if (!count || count <= 0) return [];
  return OFFICIATING_SLOTS.slice(0, Math.min(count, OFFICIATING_SLOTS.length));
}

export function defaultOfficiatingCountForFormat(matchFormat) {
  if (matchFormat === "singles") return 1;
  if (matchFormat === "doubles") return 2;
  return 1;
}

export function officiatingCountOptionsForFormat(matchFormat) {
  const max = FORMAT_MAX_OFFICIALS[matchFormat] || TENNIS_MAX_OFFICIATING_SLOTS;
  return OFFICIATING_COUNT_OPTIONS.filter((opt) => opt.count <= max);
}

export function officiatingFormatHint(matchFormat) {
  if (matchFormat === "singles") {
    return "Singles club matches often use a chair umpire; add line and roving umpires for higher-level play.";
  }
  if (matchFormat === "doubles") {
    return "Doubles benefits from a chair umpire plus line coverage; add roving umpire and referee for full crew.";
  }
  return "Choose singles or doubles above to see recommended umpiring options.";
}
